import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  Injector,
  OnDestroy
} from '@angular/core';
import {OverlayService} from '../../shared/services/overlay.service';
import { PackageVisualizerComponent } from '../package-visualizer/package-visualizer.component';
import { PortalInjector } from '@angular/cdk/portal';
import { PACKAGE_VISUALIZER_DATA } from '../core/contracts/package-visualizer.data';
import { Observable, Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { getBexFromServer, getMaintenanceReasons } from '../store/selectors/upload-bex.selectors';
import {first} from 'rxjs/operators';
import { DeploymentService } from '../core/services/deployment.service';
import { IAppState } from 'app/IAppState';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-upload-bex',
  templateUrl: './upload-bex.component.html',
  styleUrls: ['./upload-bex.component.scss']
})
export class UploadBexComponent implements OnInit, OnDestroy {
  getCurrentStatus: boolean = false;
  @ViewChild('file', { static: false}) file;
  @Input() showLoading: boolean;
  @Input() status: string;
  @Input() statusApply: string;
  @Input() error: any;
  @Input() currentBex: any;
  @Input() isProcessing = false;
  @Output() onUploadPackage = new EventEmitter<any>();
  @Output() onShowMaintenanceWindow = new EventEmitter<any>();
  @Output() onImportPackage = new EventEmitter<any>();
  @Output() onCancelImport = new EventEmitter<any>();

  public maintenanceReasons$: Observable<Array<string>>;
  private _currentBexFromServer$: Observable<any>;
  private _currentBexFromServerSubscription: Subscription;

  constructor(
    private _store: Store<IAppState>,
    private _overlayService: OverlayService,
    private injector: Injector,
    private _deploymentService: DeploymentService,
    private _toastService: BzgToastService,
    private _translateService: TranslateService,
    private _i18nService: I18nService,
    private _showToastService: ShowToastService,
  ) {
    this._currentBexFromServer$ = this._store.pipe(
      select(getBexFromServer)
    );

    this.maintenanceReasons$ = this._store.select(getMaintenanceReasons);
  }

  ngOnInit() { }

  public onFilesAdded() {
    const file = this.file.nativeElement.files[0];
    if (file) {
      if(file.name.length>200)
      {
        this._showToastService.showToast(this._i18nService.instant('DEPLOYMENT.LEN_MESSAGE_ERROR'), 'error');
      } else{
        this.onUploadPackage.emit(file);
        this.file.nativeElement.value = '';
      }
    }
  }

  ngOnDestroy(): void {
    if (this._currentBexFromServerSubscription) {
      this._currentBexFromServerSubscription.unsubscribe();
    }
  }

  public uploadPackage() {
    this.file.nativeElement.click();
  }

  public async openPackageVisualizer() {
    this._currentBexFromServerSubscription = this._currentBexFromServer$.pipe(first()).subscribe(
      (currentBexFromServer: ICurrentBexFromServer) => {
        const injector = this.createInjector(currentBexFromServer.BEX);
        this._overlayService.show(
          $('.bmc-container')[0],
          PackageVisualizerComponent,
          injector,
          async () => { }
        );
      }
    );
  }

  public showMaintenanceWindow() {
    this.onShowMaintenanceWindow.emit();
  }

  public importPackage() {
    this.getCurrentStatus = true;
    this._deploymentService.getStatusCurrentBEX().subscribe((response) => {
      this.getCurrentStatus = false;
      this.onImportPackage.emit();
    });
  }

  public cancel() {
    this.onCancelImport.emit();
  }

  private createInjector(bexInfo: IBexPackage): PortalInjector {
    const injectionTokens = new WeakMap();
    injectionTokens.set(PACKAGE_VISUALIZER_DATA,
      {
        packageId: bexInfo.Id,
        packageName: bexInfo.Filename
      }
    );
    return new PortalInjector(this.injector, injectionTokens);
  }
}
